import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router';

import styles from './NavigationLink.module.scss';

type TProps = {
  title: string;
  url: string;
};

export const NavigationLink = ({ title, url }: TProps) => (
  <Link
    className={styles['navigation-link']}
    to={url}
  >
    <span className={styles['navigation-link-text']}>{title}</span>
    <RightOutlined className={styles['navigation--link-icon']} />
  </Link>
);
